import { HttpRequest } from './http-request';

export class HttpEndpoint {
  constructor(protected _rootPath = '') {}

  getRoot(request: HttpRequest) {
    return this._rootPath;
  }
}
